import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genPresetsStyle = function genPresetsStyle(token) {
  var _$concat3;

  var componentCls = token.componentCls,
      antCls = token.antCls,
      colorTextQuaternary = token.colorTextQuaternary,
      paddingXXS = token.paddingXXS,
      colorPickerPresetColorSize = token.colorPickerPresetColorSize,
      fontSizeSM = token.fontSizeSM,
      colorText = token.colorText,
      lineHeightSM = token.lineHeightSM,
      lineWidth = token.lineWidth,
      borderRadius = token.borderRadius,
      colorFill = token.colorFill,
      colorWhite = token.colorWhite,
      marginXXS = token.marginXXS,
      paddingXS = token.paddingXS;
  return _defineProperty({}, "".concat(componentCls, "-presets"), (_$concat3 = {}, _defineProperty(_$concat3, "".concat(antCls, "-collapse-item > ").concat(antCls, "-collapse-header"), _defineProperty({
    padding: 0
  }, "".concat(antCls, "-collapse-expand-icon"), {
    height: fontSizeSM * lineHeightSM,
    color: colorTextQuaternary,
    paddingInlineEnd: paddingXXS
  })), _defineProperty(_$concat3, "".concat(antCls, "-collapse"), {
    display: 'flex',
    flexDirection: 'column',
    gap: marginXXS
  }), _defineProperty(_$concat3, "".concat(antCls, "-collapse-item > ").concat(antCls, "-collapse-content > ").concat(antCls, "-collapse-content-box"), {
    padding: "".concat(paddingXS, "px 0")
  }), _defineProperty(_$concat3, '&-label', {
    fontSize: fontSizeSM,
    color: colorText,
    lineHeight: lineHeightSM
  }), _defineProperty(_$concat3, '&-items', _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    gap: marginXXS * 1.5
  }, "".concat(componentCls, "-presets-color"), _defineProperty({
    position: 'relative',
    cursor: 'pointer',
    width: colorPickerPresetColorSize,
    height: colorPickerPresetColorSize,
    '&::before': {
      content: '""',
      pointerEvents: 'none',
      width: colorPickerPresetColorSize + 4 * lineWidth,
      height: colorPickerPresetColorSize + 4 * lineWidth,
      position: 'absolute',
      top: -2 * lineWidth,
      insetInlineStart: -2 * lineWidth,
      borderRadius: borderRadius,
      border: "".concat(lineWidth, "px solid transparent"),
      transition: "border-color ".concat(token.motionDurationMid, " ").concat(token.motionEaseInBack)
    },
    '&:hover::before': {
      borderColor: colorFill
    },
    '&::after': {
      boxSizing: 'border-box',
      position: 'absolute',
      top: '50%',
      insetInlineStart: '21.5%',
      display: 'table',
      width: colorPickerPresetColorSize / 13 * 5,
      height: colorPickerPresetColorSize / 13 * 8,
      border: "".concat(token.lineWidthBold, "px solid ").concat(token.colorWhite),
      borderTop: 0,
      borderInlineStart: 0,
      transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
      opacity: 0,
      content: '""',
      transition: "all ".concat(token.motionDurationFast, " ").concat(token.motionEaseInBack, ", opacity ").concat(token.motionDurationFast)
    }
  }, "&".concat(componentCls, "-presets-color-checked"), _defineProperty({
    '&::after': {
      opacity: 1,
      borderColor: colorWhite,
      transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
      transition: "transform ".concat(token.motionDurationMid, " ").concat(token.motionEaseOutBack, " ").concat(token.motionDurationFast)
    }
  }, "&".concat(componentCls, "-presets-color-bright"), {
    '&::after': {
      borderColor: 'rgba(0, 0, 0, 0.45)'
    }
  })))), _defineProperty(_$concat3, '&-empty', {
    fontSize: fontSizeSM,
    color: colorTextQuaternary
  }), _$concat3));
};

export default genPresetsStyle;